import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { ActiveBonusesComponent } from './active-bonuses.component';
import { DateDefaultFormatPipe } from 'src/app/pipes/date-format.pipe';


@NgModule({
  declarations: [
    ActiveBonusesComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule,
    DateDefaultFormatPipe,
  ]
})
export class ActiveBonusesModule { }